import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RecipientState } from "./recipients.state";
import { TAG_RECIPIENTS } from "./recipients.reducer";

const selectRecipientsState = createFeatureSelector<RecipientState>(TAG_RECIPIENTS);

export const selectRecipients = createSelector(selectRecipientsState, (state) => state?.recipients);
export const selectRecipientsStatus = createSelector(selectRecipientsState, (state) => state?.status);
